import { generalIconsList } from 'react-scale/components/elements/general-icons';

export const dataInputsFeatures = {
  scaleText: [
    {
      img: generalIconsList.textClassification,
      title: 'Classification'
    },
    {
      img: generalIconsList.textNamedEntityRecognition,
      title: 'Named Entity Recognition'
    },
    {
      img: generalIconsList.textTranscription,
      title: 'Transcription'
    },
    {
      img: generalIconsList.ranking,
      title: 'Ranking'
    },
    {
      img: generalIconsList.rating,
      title: 'Rating'
    },
    {
      img: generalIconsList.textGeneration,
      title: 'Generation'
    },
    {
      img: generalIconsList.textRLHF,
      title: 'RLHF'
    },
    {
      img: generalIconsList.textComparison,
      title: 'Comparison'
    },
    {
      img: generalIconsList.textPromptResponsePairs,
      title: 'Prompt-Response Pairs'
    }
  ],
  scaleAudio: [
    {
      img: generalIconsList.audioClassification,
      title: 'Classification'
    },
    {
      img: generalIconsList.audioTranscription,
      title: 'Transcription'
    }
  ],
  scale3dSensorFusion: [
    {
      img: generalIconsList['3dSensorFusionCuboid'],
      title: 'Cuboid'
    },
    {
      img: generalIconsList['3dSensorFusionSegmentation'],
      title: 'Segmentation'
    }
  ],
  scaleVideo: [
    {
      img: generalIconsList.videoBoundingBox,
      title: 'Bounding Box'
    },
    {
      img: generalIconsList.videoClassification,
      title: 'Classification'
    },
    {
      img: generalIconsList.videoCuboid,
      title: 'Cuboid'
    },
    {
      img: generalIconsList.videoMultiGeometry,
      title: 'Ellipse (Multi-Geometry)'
    },
    {
      img: generalIconsList.videoLinesAndSplines,
      title: 'Lines & Splines'
    },
    {
      img: generalIconsList.videoPoint,
      title: 'Point'
    },
    {
      img: generalIconsList.videoPolygon,
      title: 'Polygon'
    },
    {
      img: generalIconsList.videoSemanticSegmentation,
      title: 'Segmentation'
    }
  ],
  scaleMapping: [
    {
      img: generalIconsList.mappingVectors,
      title: '2D/3D Vectors'
    },
    {
      img: generalIconsList.mappingSemantic,
      title: 'Semantic'
    }
  ],
  scaleImage: [
    {
      img: generalIconsList.imageBoundingBox,
      title: 'Bounding Box'
    },
    {
      img: generalIconsList.imageClassification,
      title: 'Classification'
    },
    {
      img: generalIconsList.imageCuboid,
      title: 'Cuboid'
    },
    {
      img: generalIconsList.imageMultiGeometry,
      title: 'Ellipse (Multi-Geometry)'
    },
    {
      img: generalIconsList.imageLinesAndSplines,
      title: 'Lines & Splines'
    },
    {
      img: generalIconsList.imagePoint,
      title: 'Point'
    },
    {
      img: generalIconsList.imagePolygon,
      title: 'Polygon'
    },
    {
      img: generalIconsList.imageSemanticSegmentation,
      title: 'Segmentation'
    }
  ]
};

export const dataInputsLanguages = [
  {
    flag: 'US',
    language: 'English'
  },
  {
    flag: 'TH',
    language: 'Thai'
  },
  {
    flag: 'GR',
    language: 'Greek'
  },
  {
    flag: 'VN',
    language: 'Vietnamese'
  },
  {
    flag: 'TN',
    language: 'Turkish'
  },
  {
    flag: 'ES',
    language: 'Spanish'
  },
  {
    flag: 'RU',
    language: 'Russian'
  },
  {
    flag: 'PT',
    language: 'Portuguese'
  },
  {
    flag: 'PL',
    language: 'Polish'
  },
  {
    flag: 'KR',
    language: 'Korean'
  },
  {
    flag: 'JP',
    language: 'Japanese'
  },
  {
    flag: 'IT',
    language: 'Italian'
  },
  {
    flag: 'DE',
    language: 'German'
  },
  {
    flag: 'FR',
    language: 'French'
  },
  {
    flag: 'CN',
    language: 'Chinese'
  },
  {
    flag: 'AE',
    language: 'Arabic'
  }
];
